<div class="app-login">
  <div class="columns">
    <div class="column">
      <div class="title">{{ 'login_page_title' | translate }}</div>
      <div class="subtitle">{{ 'login_page_subtitle' | translate }}</div>

      <form [formGroup]="loginForm" class="cp-m-top-48">

        <div class="cp-field">
          <label class="cp-label" for="email">{{ 'email' | translate }}</label>
          <div class="cp-control" [class]="{'error': error()}">
            <input class="cp-input" type="email" formControlName="email" id="email">
          </div>
        </div>

        <div class="cp-field cp-m-top-24">
          <div class="cp-label-group">
            <label class="cp-label" for="password">{{ 'password' | translate }}</label>
            <span class="cp-label red cp-pointer" (click)="openForgotPasswordModal()">{{ 'forgot_password' | translate }}</span>
          </div>
          <div class="cp-control" [class]="{'error': error()}">
            <input class="cp-input" [type]="passwordVisible ? 'text' : 'password'" formControlName="password" id="password">
            <button class="cp-control-button" type="button" (click)="togglePasswordVisibility()">
              <img src="/assets/img/ic-eye.png"/>
            </button>
          </div>
        </div>

        @if (error()) {
        <div class="error">{{ 'error_wrong_credentials' | translate }}</div>
        }

        <button class="coupon-button cp-m-top-24" type="submit" [disabled]="loginForm.invalid" (click)="onSubmit()">
          {{ 'login_page_title' | translate | uppercase }}
        </button>

      </form>

      <div class="cp-footer cp-m-top-20">
        <span>{{ 'login_page_no_elite_id' | translate }}</span>
        <span class="cp-label2" (click)="goToRegisterPage()">{{ 'login_page_register' | translate }}</span>
      </div>
    </div>
  </div>
</div>
